import { render } from "./BarcodeDesc.vue?vue&type=template&id=25fc1e65"
import script from "./BarcodeDesc.vue?vue&type=script&lang=js"
export * from "./BarcodeDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__